import { Component, ViewChild } from '@angular/core';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TitleCasePipe } from '@angular/common';
import { PermissionsService } from '../../../services/permissions/permissions.service';

import { PscOcc, PscComments } from './pscCommon';
import * as moment from 'moment-mini';

import {
  HrEmployees, HrPsc,
  HrPscComments, HrOcc, HrClearanceStatus, HrDepartments, HrEmployeeJobAssignments, HrEmployeeStatus, HrEmploymentStatus, HrEmploymentType,
  HrFyPayRates, HrJobTitles, HrMaritalStatus, HrOccStatus, HrUnionAffiliation,
  HrWorkSections, HrPscType, AllStatesOrTerritories, HrPscOcc
} from '../../../../models';
import { AimsCommonConfirmDialogComponent, AimsCommonPopupEditorComponent, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component';
import { DialogComponent } from 'src/app/services/message/message.enum';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from 'src/app/services/message/message.service';
import { PscRejectCommentDialogComponent } from './psc-reject-comment-dialog/psc-reject-comment-dialog.component';

@Component({
  selector: 'psc',
  templateUrl: './psc.component.html',
  styleUrls: ['../hr.component.css'],
  providers: [TitleCasePipe]
})

export class PSCComponent {
  now: DateConstructor;
  permissionsService: PermissionsService;

  constructor(
    private transferHttp: TransferHttpService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private messageService: MessageService,
    private titlecasePipe: TitleCasePipe,
    public permissions: PermissionsService) {

  }
  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;

  // PscTypeId
  EMPLOYEE_STATUS: number = 1;
  PAY: number = 2;
  PROBATION: number = 3;
  OCC: number = 4;
  NAME_CHANGE: number = 5;
  CONTACT_INFO: number = 6;
  EMERG_CONTACT_INFO: number = 7;
  ADDRESS: number = 8;
  DRIVERS_LICENSE: number = 9;
  BRIDGED_DATE: number = 10;
  RECALL_RIGHTS: number = 11;
  ASSIGNMENT: number = 12;
  CLEARANCE: number = 13;
  CAC: number = 14;
  //PscType 15--not used
  //PscType 16--not used
  FISCAL_PAY_CHANGE: number = 17; // see PscGenerateFiscalPayComponent
  MARITAL_STATUS_CHANGE: number = 18;

  //UnionAffiliationId
  NO_REPRESENTATION: number = 4;

  //EmployeeStatusId
  REHIRE: number = 2;
  TRANSFER: number = 3;
  LAYOFF: number = 6;
  TERMINATE: number = 9;
  RESIGNATION: number = 10;
  RETIREMENT: number = 11;
  LEAVE_OF_ABSENCE: number = 12;
  MEDICAL_LEAVE: number = 13;
  OTHER: number = 14;
  NEW_HIRE: number = 15;
  RETURN_TO_DUTY: number = 16;
  SICK_FMLA: number = 17;
  WORKERS_COMP: number = 18;
  ACTIVE_WORKING: number = 19;
  ACTIVE_WORKING_RETURN_FROM_EOA: number = 20;
  ACTIVE_WORKING_EOA: number = 21;
  ACTIVE_WORKING_RETURN_FROM_MEDICAL_FMLA_WC: number = 22;
  DATA_CORRECTION: number = 23;
  ADMIN_LEAVE_PAID: number = 24;
  DECEASED: number = 25;
  ADMIN_LEAVE_UNPAID: number = 26;
  WORKER_COMP_FMLA: number = 27;

  //EmploymentStatusId
  A: number = 1;
  EOA: number = 2;
  PASS: number = 3;
  RES: number = 4;
  RET: number = 5;
  T: number = 6;

  //DepartmentId
  PROJECT_MANAGEMENT: number = 2;

  NEW: number = 0;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  //Header
  headerText = null;
  piiText = null;
  itText = null;

  //Form Control
  sendRejectEmail: boolean = false;

  newPsc: boolean = false;
  displayStatus: boolean = true;
  pscValid: boolean = false;
  pscValidStatus: string = "Loaded!";

  //PSC Route Control
  routedFrom: string = 'psc';
  rejectionCommentTxt: string = null;

  doesProbationRestart: boolean = false;
  isBridgedDateRequired: boolean = false;
  isPayChangeRequired: boolean = false;
  isMaritalStatusChangeRequired: boolean = false;

  isOccDataLoaded: boolean = false;

  isSameAddress: boolean = false;
  isLogInNameNull: boolean = false;
  isMiddleNameNull: boolean = false;

  // Arrays to cascade dropdowns

  allUnionAffiliations: HrUnionAffiliation[] = [];

  allDepartments: HrDepartments[] = [];
  filteredDepartments: HrDepartments[] = [];

  allWorkSections: HrWorkSections[] = [];
  filteredWorkSections: HrWorkSections[] = [];

  allJobTitles: HrJobTitles[] = [];
  filteredJobTitles: HrJobTitles[] = [];

  allJobAssignments: HrEmployeeJobAssignments[] = [];
  filteredJobAssignments: HrEmployeeJobAssignments[] = [];

  allStatesOrTerritories: AllStatesOrTerritories[] = [];

  allOccStatuses: HrOccStatus[] = [];

  allFyPayRates: HrFyPayRates[] = [];
  filteredFromFyPayRates: HrFyPayRates[] = [];
  filteredToFyPayRates: HrFyPayRates[] = [];

  allclearanceStatuses: HrClearanceStatus[] = [];

  allMaritalStatuses: HrMaritalStatus[] = [];

  //Field Values
  empForPsc: HrEmployees = new HrEmployees();
  psc: HrPsc = new HrPsc();

  @ViewChild('pscForm', { static: true }) pscForm; FormGroup


  allEmploymentTypes: HrEmploymentType[];
  allEmploymentStatuses: HrEmploymentStatus[];
  allSites: any[];

  allPscTypes: HrPscType[] = [];
  filteredPscTypes: HrPscType[] = [];

  allEmployeeStatuses: HrEmployeeStatus[];
  filteredEmployeeStatuses: HrEmployeeStatus[];

  //User
  user = this.transferHttp.getCache<HrEmployees>(CacheItem.user);
  today = new Date();

  //Occ Grid config
  occ: HrOcc[] = [];
  defaultPscOcc(): PscOcc {
    return new PscOcc(true);
  }
  pscOccInitialTableElement = this.defaultPscOcc();
  occTablePermissions: AimsCommonTablePermissions = {
    filter: false,
    clear: false,
    create: false,
    update: false,
    delete: false,
  };

  occTableEditRowIndex = null;

  occHeaderDisplay: string[] = ['editButton', 'jobTitleFrom', 'occDateFrom', 'primaryOccFrom', 'employmentTypeFrom', 'workSectionFrom', 'jobTitleToId', 'occDateTo', 'occStatusToId', 'primaryOccTo', 'employmentTypeToId', 'workSectionToId'];

  occHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'jobTitleFrom', label: 'From: Job Title', type: AimsCommonTableHeaderType.STRING, editable: false },
    { key: 'occDateFrom', label: 'Date', type: 'date', format: 'shortDate', width: 120, editable: false },
    { key: 'occStatusFrom', label: 'Status', type: AimsCommonTableHeaderType.STRING, editable: false },
    { key: 'primaryOccFrom', label: 'Primary?', type: AimsCommonTableHeaderType.BOOLEAN, editable: false },
    { key: 'employmentTypeFrom', label: 'Employment Type', type: AimsCommonTableHeaderType.STRING, editable: false },
    { key: 'workSectionFrom', label: 'Work Section', type: AimsCommonTableHeaderType.STRING, editable: false },
    { key: 'jobTitleToId', label: 'To: Job Title', type: AimsCommonTableHeaderType.DYNAMIC },
    { key: 'occDateTo', label: 'Date', type: 'date', format: 'shortDate', width: 120 },
    { key: 'occStatusToId', label: 'Status', type: AimsCommonTableHeaderType.DYNAMIC },
    { key: 'primaryOccTo', label: 'Primary?', type: AimsCommonTableHeaderType.BOOLEAN },
    { key: 'employmentTypeToId', label: 'Employment Type', type: AimsCommonTableHeaderType.DYNAMIC },
    { key: 'workSectionToId', label: 'Work Section', type: AimsCommonTableHeaderType.DYNAMIC },
  ];

  //DropDown Values
  departmentValues = this.transferHttp.getSingle('Common/GetAllDepartmentsForDropdown');
  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);
  siteValues = this.transferHttp.getSingle(`Common/GetAllSitesForDropdown`);
  stateOrTerritoryValues = this.transferHttp.getSingle('Common/GetAllStatesOrTerritories');
  employeeJobAssignmentValues = this.transferHttp.getSingle('Common/GetAllEmployeeJobAssignmentsForDropdown')

  pscTypeValues = this.transferHttp.getSingle('hr/GetPscType');
  workSectionValues = this.transferHttp.getSingle('hr/GetWorkSections');
  jobTitleValues = this.transferHttp.getSingle('hr/GetJobTitles');
  employeeStatusValues = this.transferHttp.getSingle('hr/GetEmployeeStatus');
  employmentStatusValues = this.transferHttp.getSingle('hr/GetEmploymentStatus');
  employmentTypeValues = this.transferHttp.getSingle('hr/GetEmploymentType');
  occStatusValues = this.transferHttp.getSingle('hr/GetOccStatus');
  fyPayRateValues = this.transferHttp.getSingle('hr/GetFyPayRates');
  unionAffiliationValues = this.transferHttp.getSingle('hr/GetUnionAffiliation');
  clearanceStatusValues = this.transferHttp.getSingle('hr/GetClearanceStatus');
  maritalStatusValues = this.transferHttp.getSingle(`hr/GetMaritalStatus`);

  //Used for aim-lookup
  stateLookupColumns:AimsCommonTableHeader[] = [
    { key: 'stateOrTerritory', label: 'State', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'postalCode', label: 'State Code', type: AimsCommonTableHeaderType.STRING, filter: true }
  ];

  fyPayLookupColumns:AimsCommonTableHeader[] = [
    { key: 'fiscalYear', label: 'Fiscal Year', filter: true, type: AimsCommonTableHeaderType.STRING,},
    { key: 'payRate', label: 'Pay Rate', filter: true,type: AimsCommonTableHeaderType.STRING, }
  ];

  employeeJobAssignmentLookupColumns:AimsCommonTableHeader[] = [
    { key: 'assignmentDescription', label: 'Assignment', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filter: true },
    { key: 'jobTitle', label: 'Job Title', type: AimsCommonTableHeaderType.STRING, filter: true }
  ];

  //Comments Grid config
  comments: HrPscComments[] = [];

  defaultPscComment(): PscComments {
    return new PscComments(this.psc.pscId, this.user);
  }
  pscCommentTablePermissions: AimsCommonTablePermissions = {
    filter: false,
    clear: false,
    create: false,
    update: false, // Set on Load Psc,
    delete: false,
  };
  pscCommentInitialTableElement = this.defaultPscComment();

  pscCommentHeader = [
    { key: 'editButton', label: 'Edit', type: 'editButton' },
    { key: 'comment', label: 'Comment', type: AimsCommonTableHeaderType.STRING, filterable: false },
    { key: 'addedBy', label: 'Added By', type: AimsCommonTableHeaderType.STRING, editable: false, filterable: false },
    { key: 'commentDate', label: 'Added On', type: 'date', format: 'shortDate', editable: false, filterable: false }
  ];

  validationData = [];

  //***************************
  // Functions
  //***************************

  public loadPsc(pscId: number) {
    this.newPsc = false;
    this.showSpinner = true;
    this.displayStatus = true;

    //Load Psc
    this.transferHttp.getHot(`hr/GetPscDetail?pscId=${pscId}`).subscribe(psc => {
      this.psc = psc;
      this.empForPsc = psc.employee;
      this.markPristine();
      this.occTablePermissions.create = this.calculateEditable();
      this.occTablePermissions.update = this.calculateEditable();
      this.pscCommentTablePermissions.create = this.canComment();

      if (this.psc.hourlyRateTo != 0 || this.psc.salaryTo != 0) {
        this.isPayChangeRequired = true;
      }
      if (this.psc.probationStartTo != null) {
        this.doesProbationRestart = true;
      }
      if (this.psc.bridgedDateOfHireTo != null) {
        this.isBridgedDateRequired = true;
      }

      if (this.calculateEditable()) {
        this.filteredDepartments = this.allDepartments;
        this.filteredWorkSections = this.allWorkSections;
        this.filteredJobTitles = this.allJobTitles;
        this.filteredJobAssignments = this.allJobAssignments;
      }

      if (this.psc.unionAffiliationCodeToId != this.NO_REPRESENTATION || this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION) {
        this.loadFyPayRates();
      }

      if (this.psc.maritalStatusToId != null) {
        this.isMaritalStatusChangeRequired = true;
      }

      if (this.psc.employeeStatusToId == this.NEW_HIRE) {
        this.occHeaderDisplay = ['jobTitleToId'];
      }

      this.headerText = 'Personnel Status Change for ' + this.empForPsc.fullName + ' - ' + this.empForPsc.employeeNumber;
      this.itText = 'Login Name: ' + this.empForPsc.loginName;
      this.piiText = 'SSN: ' + this.empForPsc.ssn + ', DOB: ' + moment(this.empForPsc.birthdate).format('L');
      this.showSpinner = false;
    });

  }

  public defaultUnion(value): void {
    if (value) {
      this.psc.unionAffiliationCodeToId = this.NO_REPRESENTATION;
    }
    else {
      this.psc.unionAffiliationCodeToId = null;
    }
  }

  public createPsc(empId: number) {

    //Set defaults
    this.newPsc = true;
    this.psc.pscTypeId = null;
    this.psc.effectiveOn = null;
    this.pscValidStatus = "New PSC";
    this.displayStatus = true;

    //Load emp
    this.transferHttp.getHot(`hr/GetEmployeeDetailForPsc?empId=${empId}`).subscribe(emp => {
      this.empForPsc = emp;
      this.calculateEditable();
      this.markPristine();
      this.occTablePermissions.create = this.calculateEditable();
      this.occTablePermissions.update = this.calculateEditable();
      this.pscCommentTablePermissions.create = this.canComment();
      this.pscCommentTablePermissions.update = this.canComment();

      this.filteredDepartments = this.allDepartments.filter(d => d.active);
      this.filteredPscTypes = this.allPscTypes;

      this.headerText = "Personnel Status Change for " + this.empForPsc.fullName + ' - ' + this.empForPsc.employeeNumber;
      this.itText = 'Login Name: ' + this.empForPsc.loginName;
      this.piiText = 'SSN: ' + this.empForPsc.ssn + ', DOB: ' + moment(this.empForPsc.birthdate).format('L');
      //console.log(this.pscForm)
    });

  }

  public createSelfServicePsc() {

    //Set defaults

    this.newPsc = true;
    this.psc.pscTypeId = null;
    this.psc.effectiveOn = null;
    this.pscValidStatus = "New Self Service PSC";
    this.displayStatus = true;

    //Load emp
    this.transferHttp.getHot(`hr/GetEmployeeDetailForPsc?empId=${this.user.employeeId}`).subscribe(emp => {
      this.empForPsc = emp;
      this.calculateEditable();
      this.pscCommentTablePermissions.create = this.canComment();
      this.pscCommentTablePermissions.update = this.canComment();
      this.filteredPscTypes = this.allPscTypes.filter(pt => pt.canSelfService);
      this.headerText = "Self Service Personnel Status Change for " + this.empForPsc.fullName + ' - ' + this.empForPsc.employeeNumber;
      //console.log(this.pscForm)
    });
  }

  public createDmSelfServicePsc(dmSsEmpId: number) {

    //Set defaults

    this.newPsc = true;
    this.psc.pscTypeId = null;
    this.psc.effectiveOn = null;
    this.pscValidStatus = "New DM Self Service PSC";
    this.displayStatus = true;

    //Load emp
    this.transferHttp.getHot(`hr/GetEmployeeDetailForPsc?empId=${dmSsEmpId}`).subscribe(emp => {
      this.empForPsc = emp;
      this.calculateEditable();
      this.occTablePermissions.create = this.calculateEditable();
      this.occTablePermissions.update = this.calculateEditable();
      this.pscCommentTablePermissions.create = this.canComment();
      this.pscCommentTablePermissions.update = this.canComment();
      this.filteredPscTypes = this.allPscTypes.filter(pt => pt.dmSelfService);
      this.headerText = "DM Self Service Personnel Status Change for " + this.empForPsc.fullName;
    });

  }

  public fillEmpData(value) {

    switch (value) {
      case this.EMPLOYEE_STATUS: {
        this.psc.lastNameFrom = this.empForPsc.lastName;
        this.psc.firstNameFrom = this.empForPsc.firstName;
        this.psc.middleNameFrom = this.empForPsc.middleName;
        this.psc.miFrom = this.empForPsc.mi;
        this.psc.akaFrom = this.empForPsc.aka;
        this.psc.loginNameFrom = this.empForPsc.loginName;
        this.psc.exemptFrom = this.empForPsc.exempt;
        this.psc.eligibleForRehireFrom = this.empForPsc.eligibleForRehire;
        this.psc.employeeStatusFrom = this.empForPsc.employeeStatus.employeeStatus;
        this.psc.employmentTypeFrom = this.empForPsc.employmentType.employmentTypeCode;
        this.psc.employmentStatusFrom = this.empForPsc.employmentStatus.employmentStatusCode;
        this.psc.unionAffiliationCodeFrom = this.empForPsc.unionAffiliation.unionAffiliationCode;
        this.psc.permanentSiteCodeFrom = this.empForPsc.permanentSite.siteCode;
        this.psc.departmentFrom = this.empForPsc.department.department;
        this.psc.workSectionFrom = this.empForPsc.workSection.workSection;
        this.psc.jobTitleFrom = this.empForPsc.title.jobTitle;
        this.psc.jobAssignmentFrom = this.empForPsc.employeeJobAssignment.assignmentDescription;
        this.psc.dispatchDateFrom = this.empForPsc.assignmentStartDate;
        this.psc.originalDateOfHireFrom = this.empForPsc.originalDateofHire;
        this.psc.bridgedDateOfHireFrom = this.empForPsc.bridgedDateofHire;
        this.psc.probationStartFrom = this.empForPsc.probationStart;

        this.psc.probationaryCompletionDateFrom = this.empForPsc.probationStart;

        this.psc.recallRightsFrom = this.empForPsc.returnTravelorRecallRights;
        this.psc.recallExpireDateFrom = this.empForPsc.recallExpireDate;

        this.isMaritalStatusChangeRequired = false;


        if (this.empForPsc.homePhone == null) {
          this.psc.primaryPhoneFrom = "000-000-0000";
        }
        else {
          this.psc.primaryPhoneFrom = this.empForPsc.homePhone;
        }

        if (this.empForPsc.messagePhone == null) {
          this.psc.alternatePhoneFrom = "000-000-0000";
        }
        else {
          this.psc.alternatePhoneFrom = this.empForPsc.messagePhone;
        }

        this.psc.emergencyContactFirstNameFrom = this.empForPsc.emergencyContactFirstName;
        this.psc.emergencyContactLastNameFrom = this.empForPsc.emergencyContactLastName;

        if (this.empForPsc.emergencyContactPhoneNo1 == null) {
          this.psc.emergencyContactPrimaryPhoneFrom = "000-000-0000";
        }
        else {
          this.psc.emergencyContactPrimaryPhoneFrom = this.empForPsc.emergencyContactPhoneNo1;
        }

        if (this.empForPsc.emergencyContactPhoneNo2 == null) {
          this.psc.emergencyContactAlternatePhoneFrom = "000-000-0000";
        }
        else {
          this.psc.emergencyContactAlternatePhoneFrom = this.empForPsc.emergencyContactPhoneNo2;
        }

        if (this.empForPsc.homeAddress != null) {
          this.psc.homeAddressFrom = this.empForPsc.homeAddress;
          this.psc.homeCityFrom = this.empForPsc.homeCity;
          this.psc.homeStateFrom = this.empForPsc.homeState.postalCode;
          this.psc.homeZipFrom = this.empForPsc.homeZip;
        }
        if (this.empForPsc.mailingAddress != null) {
          this.psc.mailingAddressFrom = this.empForPsc.mailingAddress;
          this.psc.mailingCityFrom = this.empForPsc.mailingCity;
          this.psc.mailingStateFrom = this.empForPsc.mailingState.postalCode;
          this.psc.mailingZipFrom = this.empForPsc.mailingZip;
        }
        if (this.empForPsc.clearanceStatus != null) {
          this.psc.clearanceStatusFrom = this.empForPsc.clearanceStatus.clearanceStatus;
          this.psc.clearanceDateFrom = this.empForPsc.clearanceDate;
        }
        //the driver's license information was not previously tracked so check so it does not error out
        if (this.empForPsc.driversLicense != null) {
          this.psc.driversLicenseFrom = this.empForPsc.driversLicense;
          this.psc.driversLicenseStateFrom = this.empForPsc.driversLicenseState.postalCode;
          this.psc.driversLicenseExpDateFrom = this.empForPsc.driversLicenseExpDate;
        }

        if (this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION) {
          this.loadFyPayRates();
          this.loadOccData();
        }
        break;
      }
      case this.PAY: {
        if (this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION) {
          this.loadFyPayRates();
        }
        break;
      }
      case this.PROBATION: {
        this.psc.probationaryCompletionDateFrom = this.empForPsc.probationStart;
        break;
      }
      case this.OCC: {
        if (this.psc.workSectionToId == null) {
          this.filteredWorkSections = this.allWorkSections.filter(w => w.active);
        }
        this.loadOccData();
        break;
      }
      case this.NAME_CHANGE: {
        this.psc.lastNameFrom = this.empForPsc.lastName;
        this.psc.firstNameFrom = this.empForPsc.firstName;
        this.psc.middleNameFrom = this.empForPsc.middleName;
        this.psc.miFrom = this.empForPsc.mi;
        this.psc.akaFrom = this.empForPsc.aka;
        this.psc.loginNameFrom = this.empForPsc.loginName;
        break;
      }
      case this.CONTACT_INFO: {
        this.psc.primaryPhoneFrom = this.empForPsc.homePhone;
        this.psc.alternatePhoneFrom = this.empForPsc.messagePhone;
        break;
      }
      case this.EMERG_CONTACT_INFO: {
        this.psc.emergencyContactFirstNameFrom = this.empForPsc.emergencyContactFirstName;
        this.psc.emergencyContactLastNameFrom = this.empForPsc.emergencyContactLastName;
        this.psc.emergencyContactPrimaryPhoneFrom = this.empForPsc.emergencyContactPhoneNo1;
        this.psc.emergencyContactAlternatePhoneFrom = this.empForPsc.emergencyContactPhoneNo2;
        break;
      }
      case this.ADDRESS: {
        this.psc.homeAddressFrom = this.empForPsc.homeAddress;
        this.psc.homeCityFrom = this.empForPsc.homeCity;
        this.psc.homeStateFrom = this.empForPsc.homeState.postalCode;
        this.psc.homeZipFrom = this.empForPsc.homeZip;
        this.psc.mailingAddressFrom = this.empForPsc.mailingAddress;
        this.psc.mailingCityFrom = this.empForPsc.mailingCity;
        this.psc.mailingStateFrom = this.empForPsc.mailingState.postalCode;
        this.psc.mailingZipFrom = this.empForPsc.mailingZip;
        break;
      }
      case this.DRIVERS_LICENSE: {
        //the driver's license information was not previously tracked so check so it does not error out
        if (this.empForPsc.driversLicense != null) {
          this.psc.driversLicenseFrom = this.empForPsc.driversLicense;
          this.psc.driversLicenseStateFrom = this.empForPsc.driversLicenseState.postalCode;
          this.psc.driversLicenseExpDateFrom = this.empForPsc.driversLicenseExpDate;
        }
        break;
      }
      case this.BRIDGED_DATE: {
        this.psc.bridgedDateOfHireFrom = this.empForPsc.bridgedDateofHire;
        break;
      }
      case this.RECALL_RIGHTS: {
        this.psc.recallRightsFrom = this.empForPsc.returnTravelorRecallRights;
        this.psc.recallExpireDateFrom = this.empForPsc.recallExpireDate;
        break;
      }
      case this.ASSIGNMENT: {
        this.psc.jobTitleFrom = this.empForPsc.title.jobTitle;
        this.psc.jobAssignmentFrom = this.empForPsc.employeeJobAssignment.assignmentDescription;

        if (this.isPayChangeRequired && this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION) {
          this.loadFyPayRates();
        }

        this.loadOccData();
        break;
      }
      case this.CLEARANCE: {
        this.psc.clearanceStatusFrom = this.empForPsc.clearanceStatus.clearanceStatus;
        this.psc.clearanceDateFrom = this.empForPsc.clearanceDate;
        break;
      }
      case this.CAC: {
        this.psc.cacExpDateFrom = this.empForPsc.cacExpireDate;
        break;
      }
      case this.MARITAL_STATUS_CHANGE: {
        this.psc.maritalStatusFrom = this.empForPsc.maritalStatus.maritalStatus;
        break;
      }

      default: {
        break;
      }
    }

  }

  public decideWhatGetsDisplayed(): boolean {

    if (this.psc.employeeStatusToId == this.LAYOFF) {
      this.psc.employmentStatusToId = this.T;
      return true;
    }
    else if (this.psc.employeeStatusToId == this.TERMINATE) {
      this.psc.employmentStatusToId = this.T;
      return true;
    }
    else if (this.psc.employeeStatusToId == this.DECEASED) {
      this.psc.eligibleForRehireTo = false;
      this.psc.employmentStatusToId = this.PASS;
      return true;
    }
    else if (this.psc.employeeStatusToId == this.RESIGNATION) {
      this.psc.employmentStatusToId = this.RES;
      return true;
    }
    else if (this.psc.employeeStatusToId == this.RETIREMENT) {
      this.psc.employmentStatusToId = this.RET;
      return true;
    }
    else if (this.psc.employeeStatusToId == this.NEW_HIRE ||
      this.psc.employeeStatusToId == this.REHIRE) {
      this.psc.employmentStatusToId = this.A;
      return true;
    }
    else if (this.psc.employeeStatusToId == this.ACTIVE_WORKING ||
      this.psc.employeeStatusToId == this.ACTIVE_WORKING_RETURN_FROM_EOA ||
      this.psc.employeeStatusToId == this.ACTIVE_WORKING_RETURN_FROM_MEDICAL_FMLA_WC) {
      this.psc.employmentStatusToId = this.A;
      return false;
    }
    else if (this.psc.employeeStatusToId == this.ACTIVE_WORKING_EOA) {
      this.psc.employmentStatusToId = this.EOA;
      return false;
    }
    else {
      this.psc.employmentStatusToId = this.A
      return false;
    }
  }

  public loadFyPayRates() {

    if (this.psc.pscTypeId == this.PAY) {
      this.filteredFromFyPayRates = this.allFyPayRates.filter(s => s.jobTitleId == this.empForPsc.titleId);
      this.filteredToFyPayRates = this.allFyPayRates.filter(s => s.jobTitleId == this.empForPsc.titleId);
    }
    else if (this.isPayChangeRequired || this.psc.pscTypeId == this.EMPLOYEE_STATUS && this.psc.jobTitleToId != null) {
      this.filteredFromFyPayRates = this.allFyPayRates.filter(s => s.jobTitleId == this.empForPsc.titleId);
      this.filteredToFyPayRates = this.allFyPayRates.filter(s => s.jobTitleId == this.psc.jobTitleToId);
    }
    else if (this.psc.pscTypeId == this.EMPLOYEE_STATUS && (this.psc.unionAffiliationCodeToId == null && this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION)) {
      this.filteredFromFyPayRates = this.allFyPayRates.filter(s => s.jobTitleId == this.empForPsc.titleId);
      this.filteredToFyPayRates = this.allFyPayRates.filter(s => s.jobTitleId == this.empForPsc.titleId);
    }
  }

  public loadOccData() {
    if ((this.psc.pscTypeId == this.OCC || this.psc.pscTypeId == this.EMPLOYEE_STATUS || this.psc.pscTypeId == this.ASSIGNMENT) &&
      this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION && !this.isOccDataLoaded) {
      this.isOccDataLoaded = true;
      for (let occ of this.empForPsc.hrOcc) {
        let pscOcc = new PscOcc();

        pscOcc.occId = occ.occId,
          pscOcc.occDateFrom = occ.occDate,
          pscOcc.occStatusFrom = (this.allOccStatuses.filter(os => os.occStatusId == occ.occStatusId).map(os => os.occStatus)).toString(),
          pscOcc.primaryOccFrom = occ.primaryOcc,
          pscOcc.jobTitleFrom = (this.allJobTitles.filter(jt => jt.jobTitleId == occ.jobTitleId).map(jt => jt.jobTitle)).toString(),
          pscOcc.employmentTypeFrom = (this.allEmploymentTypes.filter(et => et.employmentTypeId == occ.employmentTypeId).map(et => et.employmentTypeCode)).toString(),
          pscOcc.workSectionFrom = (this.allWorkSections.filter(ws => ws.workSectionId == occ.workSectionId).map(ws => ws.workSection)).toString(),

          this.psc.hrPscOcc.push(pscOcc);
      }
    }
  }

  public handleRequiresPayChange() {
    if (this.isPayChangeRequired) {
      this.loadFyPayRates();
    }
  }


  public handleRequiresMaritalStatusChange() {
    if (this.isMaritalStatusChangeRequired) {
      this.psc.maritalStatusFrom = this.empForPsc.maritalStatus.maritalStatus;
    }
    else {
      this.psc.maritalStatusFrom = null;
    }
  }

  public handleUnionHourlyRateFromChg(e) {
    this.psc.hourlyRateFrom = +(this.filteredFromFyPayRates.filter(r => r.fyPayRateId == e).map(r => r.payRate).pop());
    this.psc.overTimeRateFrom = +(this.psc.hourlyRateFrom * 1.5).toFixed(4);
    this.psc.salaryFrom = 0;
    this.psc.biWeeklyRateFrom = 0;
  }

  public handleUnionHourlyRateToChg(e) {
    this.psc.hourlyRateTo = +(this.filteredToFyPayRates.filter(r => r.fyPayRateId == e).map(r => r.payRate).pop());
    this.psc.overTimeRateTo = +(this.psc.hourlyRateTo * 1.5).toFixed(4);
    this.psc.salaryTo = 0;
    this.psc.biWeeklyRateTo = 0;
  }

  public handleHourlyRateFromChg(value: number) {
    this.psc.overTimeRateFrom = +(value * 1.5).toFixed(4);
    this.psc.salaryFrom = 0;
    this.psc.biWeeklyRateFrom = 0;
  }

  public handleHourlyRateToChg(value: number) {
    this.psc.overTimeRateTo = +(value * 1.5).toFixed(4);
    this.psc.salaryTo = 0;
    this.psc.biWeeklyRateTo = 0;
  }

  public handleSalaryFromChg(value: number) {
    this.psc.biWeeklyRateFrom = +(value / 26);
    this.psc.hourlyRateFrom = 0;
    this.psc.overTimeRateFrom = 0;
  }

  public handleSalaryToChg(value: number) {
    this.psc.biWeeklyRateTo = +(value / 26);
    this.psc.hourlyRateTo = 0;
    this.psc.overTimeRateTo = 0;
  }


  public handleHomeStreetChanged() {
    if (this.isSameAddress) {
      this.psc.mailingAddressTo = this.psc.homeAddressTo;
    }
  }

  public handleHomeCityChanged() {
    if (this.isSameAddress) {
      this.psc.mailingCityTo = this.psc.homeCityTo;
    }
  }

  public handleHomeStateChanged(homeStateToId) {
    if (this.isSameAddress) {
      this.psc.mailingStateToId = homeStateToId;
    }
  }

  public handleHomeZipChanged() {
    if (this.isSameAddress) {
      this.psc.mailingZipTo = this.psc.homeZipTo;
    }
  }


  public handleSameAddressChecked() {
    if (this.isSameAddress) {
      if (this.psc.homeAddressTo != null) {
        this.psc.mailingAddressTo = this.psc.homeAddressTo;
      }
      else {
        this.psc.mailingAddressTo = null;
      }
      if (this.psc.homeCityTo != null) {
        this.psc.mailingCityTo = this.psc.homeCityTo;
      }
      else {
        this.psc.mailingCityTo = null;
      }

      if (this.psc.homeStateToId != null) {
        this.psc.mailingStateToId = this.psc.homeStateToId;
      }
      else {
        this.psc.mailingStateToId = null;
      }

      if (this.psc.homeZipTo != null) {
        this.psc.mailingZipTo = this.psc.homeZipTo;
      }
      else {
        this.psc.mailingZipTo = null;
      }

    }
    else if (!this.isSameAddress) {
      this.psc.mailingAddressTo = null;
      this.psc.mailingCityTo = null;
      this.psc.mailingStateToId = null;
      this.psc.mailingZipTo = null;
    }
  }


  markPristine() {
    //Do this so the save button doesn't light up
    this.pscForm.form.markAsPristine();
  }
  markAsDirty() {
    //Doing this because marking the form as dirty gets reset
    this.pscForm.form.get("Name").markAsDirty()
  }

  handlePscOccTableRowUpdate(update: TableRowUpdate): void {
    const occ = update.newRow as HrPscOcc
    this.psc.hrPscOcc[update.index] = occ
    this.psc.hrPscOcc = [...this.psc.hrPscOcc]
    this.markAsDirty();
  }
  handlePscOccTableRowAdd(update: TableRowUpdate): void {
    const occ = update.newRow as HrPscOcc
    this.psc.hrPscOcc = [occ, ...this.psc.hrPscOcc]
    this.markAsDirty();
  }

  handlePscCommentsTableRowUpdate(update: TableRowUpdate): void {
    const comment = update.newRow as HrPscComments
    comment.commentDate = new Date();
    comment.addedBy = this.user.fullName;
    this.psc.hrPscComments[update.index] = comment
    this.psc.hrPscComments = [...this.psc.hrPscComments]
    this.markAsDirty();
  }
  handlePscCommentsTableRowAdd(update: TableRowUpdate): void {
    const comment = update.newRow as HrPscComments
    this.psc.hrPscComments = [comment, ...this.psc.hrPscComments]
    this.markAsDirty();
  }


  public calculateEditable(): boolean {
    let returnVal = false;

    if (this.permissions.canUpdate(this.permissions.ComponentID.PSC) && !this.psc.submitted && !this.psc.rejected) {
      returnVal = true;
    }
    return returnVal;
  }

  public calculateRequired(routedFrom: string): boolean {
    let returnVal = false;

    if (this.psc.pscTypeId != 0 && this.psc.pscTypeId != undefined) {
      let pscType = this.allPscTypes.filter(pt => pt.pscTypeId == this.psc.pscTypeId)[0];
      if (this.psc.pscTypeId == this.EMPLOYEE_STATUS) {
        let empStatus = this.allEmployeeStatuses.filter(es => es.employeeStatusId == this.psc.employeeStatusToId)[0];
        if (empStatus != undefined) {
          switch (routedFrom) {
            case 'pscWsLeadReview': {
              returnVal = (pscType.wsLeadReviewRequired && empStatus.wsLeadReviewRequired);
              break;
            }
            case 'pscHrRouting': {
              returnVal = (pscType.hrAuditRequired && empStatus.hrAuditRequired);
              break;
            }
            case 'pscDmApproval': {
              returnVal = (pscType.dmApprovalRequired && empStatus.dmApprovalRequired);
              break;
            }
            case 'pscPmmApproval': {
              returnVal = (pscType.pmmApprovalRequired && empStatus.pmmApprovalRequired);
              break;
            }
            case 'pscHrmApproval': {
              returnVal = (pscType.hrmApprovalRequired && empStatus.hrmApprovalRequired);
              break;
            }
            case 'pscAcctReceival': {
              returnVal = (pscType.acctReceivalRequired && empStatus.acctReceivalRequired);
              break;
            }
            case 'pscItReceival': {
              returnVal = (pscType.itReceivalRequired && empStatus.itReceivalRequired);
              break;
            }
          }
        }
      }
      else {
        switch (routedFrom) {
          case 'pscWsLeadReview': {
            returnVal = pscType.wsLeadReviewRequired;
            break;
          }
          case 'pscHrRouting': {
            returnVal = pscType.hrAuditRequired;
            break;
          }
          case 'pscDmApproval': {
            returnVal = pscType.dmApprovalRequired;
            break;
          }
          case 'pscPmmApproval': {
            returnVal = pscType.pmmApprovalRequired;
            break;
          }
          case 'pscHrmApproval': {
            returnVal = pscType.hrmApprovalRequired;
            break;
          }
          case 'pscAcctReceival': {
            returnVal = pscType.acctReceivalRequired;
            break;
          }
          case 'pscItReceival': {
            returnVal = pscType.itReceivalRequired;
            break;
          }
        }
      }
    }
    else {
      returnVal = false;
    }
    return returnVal;
  }

  //Cancel
  public cancelPsc() {
    var message = this.messageService.getDialogMessage(DialogComponent.UnsavedChanges);
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
      data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        if (this.routedFrom == "selfServicePsc") {
        this.router.navigate([`/hr`]);
      }
      else if (this.routedFrom == "dmSelfServicePsc") {
        this.router.navigate([`/hr`]);
      }
      else {
        this.router.navigate([`/hr/viewEmployees`]);
      }
      }
      dialogRef = null;
    });
  }

  //Update route
  public updatePscRoute(route: string) {
    let itReq: boolean = false;
    let acctReq: boolean = false;

    switch (route) {
      case 'Create PSC': {
        this.newPsc = false;
        this.psc.employeeId = this.empForPsc.employeeId;
        this.psc.createdBy = this.user.fullName;
        this.psc.createdOn = this.today;
        this.pscValidStatus = "Created and submitted for HR audit!"
        this.spinnerText = "Creating PSC...";
        break;
      }
      case 'Save': {
        this.spinnerText = "Saved changes...";
        break;
      }
      case 'HR audit': {
        this.psc.hrAuditedOn = this.today;
        this.psc.hrAuditedBy = this.user.fullName;
        this.psc.audited = true;
        this.spinnerText = "HR audited...";
        break;
      }
      case 'HR Manager audit': {
        this.psc.hrAuditedOn = this.today;
        this.psc.hrAuditedBy = this.user.fullName;
        this.psc.audited = true;
        this.spinnerText = "HR Manager audited...";
        break;
      }
      case 'Rejected': {
        this.openRejectComment();
        break;
      }
      case 'pscWsLeadReview': {
        this.psc.wsLeadReviewedOn = this.today;
        this.psc.wsLeadReviewedBy = this.user.fullName;
        this.pscValidStatus = "WS Lead Reviewed"
        this.spinnerText = "WS Lead Reviewed PSC...";
        break;
      }
      case 'pscDmApproval': {
        this.psc.dmApprovedOn = this.today;
        this.psc.dmApprovedBy = this.user.fullName;
        this.psc.dmAppEmpId = this.user.employeeId;
        this.pscValidStatus = "DM Approved"
        this.spinnerText = "DM Approved PSC...";
        break;
      }
      case 'pscPmmApproval': {
        this.psc.submitted = true;
        this.psc.pmmApprovedOn = this.today;
        this.psc.pmmApprovedBy = this.user.fullName;
        this.psc.pmmAppEmpId = this.user.employeeId;
        this.pscValidStatus = "PMM Approved"
        this.spinnerText = "PMM Approved PSC and submitted...";
        break;
      }
      case 'pscHrmApproval': {
        this.psc.submitted = true;
        // allow HRM to Audit and Approve by just clicking one button
        if (this.psc.hrAuditedOn == null) {
          this.psc.hrAuditedBy = this.user.fullName;
          this.psc.hrAuditedOn = this.today;
        }
        this.psc.hrmApprovedOn = this.today;
        this.psc.hrmApprovedBy = this.user.fullName;
        this.psc.hrmAppEmpId = this.user.employeeId;
        this.pscValidStatus = "HRM Approved && submitted"
        this.spinnerText = "HRM Approved PSC and submitted...";
        break;
      }
      case 'pscAcctReceival': {
        this.psc.acctReceivedOn = this.today;
        this.psc.acctReceivedBy = this.user.fullName;
        this.pscValidStatus = "Acct Received"
        this.spinnerText = "Acct Received PSC...";
        break;
      }
      case 'pscItReceival': {
        this.psc.itReceivedOn = this.today;
        this.psc.itReceivedBy = this.user.fullName;
        this.pscValidStatus = "IT Received"
        this.spinnerText = "IT Received PSC...";
        break;
      }
      case 'Accepted': {
        this.pscValidStatus = "PSC was accepted by HR!"
        this.spinnerText = "HR accepted...";
        this.psc.accepted = true;
        break;
      }
      case 'Print': {
        if (this.routedFrom == 'pscHrAccepted' || this.routedFrom == 'pscHrmAccepted') {
          this.psc.printedHr = true;
          break;
        }
        else {
          this.psc.printedAcct = true;
          break;
        }
      }
      default: {
        break;
      }
    }

    if ((this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION || this.psc.unionAffiliationCodeToId != this.NO_REPRESENTATION) &&
      (this.psc.pscTypeId == this.OCC)) {
      this.updatePscOccToData();
    }
    else if ((this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION || this.psc.unionAffiliationCodeToId != this.NO_REPRESENTATION) &&
      (this.psc.pscTypeId == this.EMPLOYEE_STATUS || this.psc.pscTypeId == this.ASSIGNMENT)) {
      this.updatePscToData();
      this.updatePscOccToData();
    }
    else {
      this.updatePscToData();
    }

    let resetProbationaryCompletionDate: boolean = false;
    if (this.psc.pscTypeId == this.EMPLOYEE_STATUS && this.psc.employeeStatusTo == "Rehire" && this.doesProbationRestart && this.psc.probationStartTo) {
        resetProbationaryCompletionDate = true;
    }

    this.transferHttp.put(`hr/SavePsc?resetProbationaryCompletionDate=${resetProbationaryCompletionDate}`, this.psc).subscribe(retVal => {
      var dmDeptId: number;
      var wsLeadDeptId: number;

      if (this.psc.departmentToId != null) {
        dmDeptId = this.psc.departmentToId;
      }
      else {
        dmDeptId = this.empForPsc.departmentId;
      }

      if (this.psc.workSectionToId != null) {
        wsLeadDeptId = this.psc.workSectionToId;
      }
      else {
        wsLeadDeptId = this.empForPsc.workSectionId;
      }


      if (route == 'Print') {
        this.printPsc(this.psc.pscId);
      }
      else if (this.calculateRequired('pscPmmApproval') && this.psc.pmmAppEmpId == null && route == 'pscDmApproval' && this.psc.dmAppEmpId != null) {

        this.transferHttp.get(`hr/SendDmApprovedEmail?pscId=${this.psc.pscId}&pmmDeptId=${this.PROJECT_MANAGEMENT}`).subscribe();
      }
      else if (route == 'pscHrmApproval' && this.psc.submitted) {

        this.transferHttp.get(`hr/SendSubmittedEmail?pscId=${this.psc.pscId}
            &wsLeadReq=${this.calculateRequired('pscWsLeadReview')}&wsLeadDeptId=${wsLeadDeptId}
            &dmReq=${this.calculateRequired('pscDmApproval')}&dmDeptId=${dmDeptId}
            &pmmReq=${this.calculateRequired('pscPmmApproval')}&pmmDeptId=${this.PROJECT_MANAGEMENT}`).subscribe();
      }
      else if (route == 'Accepted') {

        if (this.psc.employeeStatusToId == this.TERMINATE ||
          this.psc.employeeStatusToId == this.RESIGNATION ||
          this.psc.employeeStatusToId == this.RETIREMENT ||
          this.psc.employeeStatusToId == this.LAYOFF ||
          this.psc.employeeStatusToId == this.DECEASED) {

          this.transferHttp.put(`User/RemoveAllPermissions?empId=${this.psc.employeeId}`, null).subscribe();

        }

        if ((this.psc.pscTypeId == this.CONTACT_INFO || this.psc.pscTypeId == this.EMERG_CONTACT_INFO || this.psc.pscTypeId == this.ADDRESS || this.psc.pscTypeId == this.DRIVERS_LICENSE) ||
          (this.calculateRequired('pscItReceival') && this.psc.itReceivedOn == null) ||
          (!this.calculateRequired('pscItReceival') && (this.calculateRequired('pscAcctReceival') && this.psc.acctReceivedOn == null))) {

          this.transferHttp.get(`hr/SendAcceptedEmail?pscId=${this.psc.pscId}&routedFrom=${route}&itReq=${this.calculateRequired('pscItReceival')}&acctReq=${this.calculateRequired('pscAcctReceival')}`).subscribe();

        }
      }
      else if (route == 'pscItReceival') {
        if ((this.calculateRequired('pscAcctReceival') && this.psc.acctReceivedOn == null)) {

          this.transferHttp.get(`hr/SendAcceptedEmail?pscId=${this.psc.pscId}&routedFrom=${route}&itReq=${this.calculateRequired('pscItReceival')}&acctReq=${this.calculateRequired('pscAcctReceival')}`).subscribe();

        }
      }


      if (retVal.id > 0) {
        if (this.routedFrom == 'selfServicePsc' || this.routedFrom == 'dmSelfServicePsc') {
          this.router.navigate([`/hr`]);
        }
        else {
          this.loadPsc(retVal.id);
        }
      }
      else {
        this.pscValidStatus = "PSC Save failed"
      }
    });


  }

  printPsc(pscId: number) {

    if (this.routedFrom == 'pscHrAccepted' || this.routedFrom == 'pscHrmAccepted') {
      this.router.navigate([`reporting/PSC_For_HR/trdp/{"PscId":"${pscId}"}`]);
    }
    else {
      this.router.navigate([`reporting/PSC_For_Acct/trdp/{"PscId":"${pscId}"}`]);
    }

  }


  //validate/update fistName, lastName, loginName, and SSN
  public validateUserInput(event: any): void {

    this.displayStatus = true;

    if (event.currentTarget.id == "firstNameTo") {
      let loginName1: string;
      let loginName2: string;
      let trimExtra2: number;

      //this.psc.firstNameTo = this.titlecasePipe.transform(this.psc.firstNameTo)
      //this.psc.lastNameTo = this.titlecasePipe.transform(this.psc.lastNameTo)

      // loginName
      let loginNameTo = (this.psc.firstNameTo.replace(/([^a-z0-9]+)/gi, "") + "." + this.psc.lastNameTo.replace(/([^a-z0-9]+)/gi, "")).toLowerCase();

      let checkLoginName = this.validationData.filter(e => {
        loginName1 = (e.firstName.replace(/([^a-z0-9]+)/gi, "") + "." + e.lastName.replace(/([^a-z0-9]+)/gi, "")).toLowerCase();
        loginName2 = e.loginName;

        if (loginName2 != null) {
          loginName2 = loginName2.toLowerCase();
        }


        if (loginName1 == loginNameTo) {
          return (loginName1 == loginNameTo);
        }
        else if (loginName2 != null && (loginName2 == loginNameTo)) {
          return (loginName2 == loginNameTo);
        }
        else {
          return 0
        }
      });

      if (checkLoginName.length == 0) {
        this.psc.loginNameTo = loginNameTo;
      }
      else {
        alert("Login Name: " + loginNameTo + " already exists!");
        this.psc.loginNameTo = loginNameTo + checkLoginName.length.toString();
      }

      //event.currentTarget.value = this.titlecasePipe.transform(event.currentTarget.value);
    }
    else if (event.currentTarget.id == 'loginNameTo') {
      let loginName2: string;
      // loginName
      let loginNameTo = (this.psc.loginNameTo.replace(/([^a-z0-9.]+)/gi, "")).toLowerCase();
      let checkLoginName = this.validationData.filter(e => {
        loginName2 = e.loginName;

        if (loginName2 != null) {
          loginName2 = loginName2.toLowerCase();
        }


        if (loginName2 != null && (loginName2 == loginNameTo)) {
          return (loginName2 == loginNameTo);
        }
        else {
          return 0
        }
      });

      if (checkLoginName.length == 0) {
        this.psc.loginNameTo = loginNameTo;
      }
      else {
        alert("Login Name: " + loginNameTo + " already exists!");
        this.psc.loginNameTo = loginNameTo + checkLoginName.length.toString();
      }

      event.currentTarget.value = event.currentTarget.value.toLowerCase();
    }
    else if (event.currentTarget.id == 'middleNameTo') {

      if ((this.psc.middleNameTo == null || this.psc.middleNameTo == '' || this.psc.middleNameTo == '(nmn)' || this.psc.middleNameTo == '(NMN)')) {
        this.psc.middleNameTo = '(NMN)';
        this.psc.miTo = null;
      }
      else {
        //this.psc.middleNameTo = this.titlecasePipe.transform(event.currentTarget.value);
        this.psc.miTo = this.titlecasePipe.transform(event.currentTarget.value.charAt(0));
      }
    }
    else if (event.currentTarget.id == 'akaTo') {
      this.psc.akaTo = this.titlecasePipe.transform(event.currentTarget.value);
    }
    else if (event.currentTarget.id == 'emergencyContactLastNameTo') {
      this.psc.emergencyContactLastNameTo = this.titlecasePipe.transform(event.currentTarget.value);
    }
    else if (event.currentTarget.id == 'emergencyContactFirstNameTo') {
      this.psc.emergencyContactFirstNameTo = this.titlecasePipe.transform(event.currentTarget.value);
    }
    else {
      return;
    }
  }

  public handleEmployeeStatusChanged() {

    this.psc.employeeStatusTo = this.allEmployeeStatuses.filter(e => e.employeeStatusId == this.psc.employeeStatusToId).map(e => e.employeeStatus).toString();

    this.psc.exemptTo = this.psc.exemptFrom;
    this.decideWhatGetsDisplayed();
    this.isLogInNameNull = this.checkForNullLogInName();
    this.isMiddleNameNull = this.checkForNullMiddleName();
    this.psc.eligibleForRehireTo = this.empForPsc.eligibleForRehire;

    if (this.psc.employeeStatusToId == this.NEW_HIRE) {
      this.occHeaderDisplay = ['jobTitleToId'];
    }
  }

  public checkForNullLogInName(): boolean {
    if (this.empForPsc.loginName == null) {
      return true;
    }
    else {
      return false;
    }
  }

  public checkForNullMiddleName(): boolean {
    if (this.empForPsc.middleName == null && this.empForPsc.mi != null) {
      return true;
    }
    else {
      return false;
    }
  }

  public isNewPsc(): boolean {
    let returnVal = false;

    // determine when to show Save button

    if (this.newPsc) {
      returnVal = true;
    }
    return returnVal;
  }


  public canRoute(): boolean {
    let returnVal = false;

    // Authorize which employees can routePSCs

    if (this.psc.rejected || this.psc.accepted) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscHrRoutingQueue) ||
      this.permissions.canUpdate(this.permissions.ComponentID.PscHrmApprovalQueue) ||
      this.permissions.canUpdate(this.permissions.ComponentID.PscPmmApprovalQueue)) {
      returnVal = true;
    }
    return returnVal;
  }

  public canSave(): boolean {
    let returnVal = false;

    // determine when to show Save button

    if (this.newPsc || this.psc.rejected || this.psc.audited || this.psc.submitted) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PSC)) {
      returnVal = true;
    }
    return returnVal;
  }

  public canAudit(): boolean {
    let returnVal = false;

    // Authorize which employees can audit PSCs

    if (this.psc.audited || this.psc.rejected || this.psc.accepted) {
      returnVal = false;
    }
    else if (this.routedFrom == 'pscHrRouting' && this.psc.hrAuditedOn == null &&
      (this.psc.unionAffiliationCodeToId != this.NO_REPRESENTATION && this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION)
      && this.permissions.canUpdate(this.permissions.ComponentID.PscHrRoutingQueue) && this.calculateRequired('pscHrRouting')) {
      if (this.user.fullName != this.psc.createdBy) {
        returnVal = true;
      }
    }
    return returnVal;
  }


  public canSubmit(): boolean {
    let returnVal = false;

    // Authorize which employees can submit PSCs after they have been audited by HR
    if (this.psc.submitted || this.psc.rejected || this.psc.accepted) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscHrmApprovalQueue) && this.psc.audited) {
      returnVal = true;
    }
    return returnVal;
  }

  public canReject(): boolean {
    let returnVal = false;

    if (this.newPsc || this.psc.rejected || this.psc.accepted) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscHrRoutingQueue) ||
      this.permissions.canUpdate(this.permissions.ComponentID.PscHrmApprovalQueue)) {
      returnVal = true;
    }
    else if (this.psc.submitted && (this.permissions.canUpdate(this.permissions.ComponentID.PscDmApprovalQueue) ||
      this.permissions.canUpdate(this.permissions.ComponentID.PscPmmApprovalQueue))) {
      returnVal = true;
    }
    return returnVal;
  }

  public canAccept(): boolean {
    let returnVal = false;

    if (this.psc.rejected || this.psc.accepted) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscHrRoutingQueue) || this.permissions.canUpdate(this.permissions.ComponentID.PscHrmApprovalQueue)) {
      if (((this.calculateRequired('pscDmApproval') && this.psc.dmApprovedOn != null) || !this.calculateRequired('pscDmApproval')) &&
        ((this.calculateRequired('pscHrmApproval') && this.psc.hrmApprovedOn != null) || !this.calculateRequired('pscHrmApproval')) &&
        ((this.calculateRequired('pscPmmApproval') && this.psc.pmmApprovedOn != null) || !this.calculateRequired('pscPmmApproval'))) {
        returnVal = true;
      }
    }
    return returnVal;
  }

  public canPrint(): boolean {
    let returnVal = false;

    if ((this.routedFrom == 'pscHrAccepted' && this.empForPsc.unionAffiliationId != this.NO_REPRESENTATION) ||
      (this.routedFrom == 'pscHrmAccepted')) {
      if (((this.calculateRequired('pscDmApproval') && this.psc.dmApprovedOn != null) || !this.calculateRequired('pscDmApproval')) &&
        ((this.calculateRequired('pscHrmApproval') && this.psc.hrmApprovedOn != null) || !this.calculateRequired('pscHrmApproval')) &&
        ((this.calculateRequired('pscPmmApproval') && this.psc.pmmApprovedOn != null) || !this.calculateRequired('pscPmmApproval')) &&
        ((this.calculateRequired('pscAcctReceival') && this.psc.acctReceivedOn != null) || !this.calculateRequired('pscAcctReceival')) &&
        ((this.calculateRequired('pscItReceival') && this.psc.itReceivedOn != null) || !this.calculateRequired('pscItReceival'))) {
        returnVal = true;
      }
    }
    else if ((this.routedFrom == 'pscAcctReceived' || this.routedFrom == 'pscAcctReceival') && this.psc.acctReceivedOn != null) {
      returnVal = true;
    }
    else {
      returnVal = false;
    }
    return returnVal;
  }

  public canComment(): boolean {
    let returnVal = this.calculateEditable();

    if (this.psc.rejected || this.psc.accepted) {
      returnVal = false;
    }
    else if (this.newPsc){
      returnVal = true;
    }
    else if (this.routedFrom == 'pscHrRouting' || this.routedFrom == 'pscHrmApproval' || this.routedFrom == 'selfServicePsc' || this.routedFrom == 'dmSelfServicePsc') {
      returnVal = true;
    }
    else if (this.psc.submitted) {
      if (
        (this.routedFrom == 'pscWsLeadReview' && this.calculateRequired('pscWsLeadReview') && this.psc.wsLeadReviewedOn == null) ||
        (this.routedFrom == 'pscDmApproval' && this.calculateRequired('pscDmApproval') && this.psc.dmApprovedOn == null) ||
        (this.routedFrom == 'pscPmmApproval' && this.calculateRequired('pscPmmApproval') && this.psc.pmmApprovedOn == null)) {
        returnVal = true;
      }
    }
    return returnVal;
  }


  public canWSLeadReview(): boolean {
    let returnVal = false;

    if (this.psc.rejected) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscWsLeadReviewQueue)
      && this.calculateRequired('pscWsLeadReview') && this.psc.wsLeadReviewedOn == null) {
      returnVal = true;
    }
    return returnVal;
  }

  public canDmApprove(): boolean {
    let returnVal = false;

    if (this.psc.rejected || this.psc.accepted) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscDmApprovalQueue) &&
      this.calculateRequired('pscDmApproval') && this.psc.dmApprovedOn == null) {
      returnVal = true;
    }
    return returnVal;
  }

  public canHrmApprove(): boolean {
    let returnVal = false;

    if (this.psc.rejected || this.psc.accepted) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscHrmApprovalQueue) &&
      this.calculateRequired('pscHrmApproval') && this.psc.hrmApprovedOn == null) {
      returnVal = true;
    }
    return returnVal;
  }

  public canPmmApprove(): boolean {
    let returnVal = false;

    if (this.psc.rejected || this.psc.accepted) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscPmmApprovalQueue) &&
      (this.calculateRequired('pscPmmApproval') && this.psc.pmmApprovedOn == null)) {
      returnVal = true;
    }
    return returnVal;
  }

  public canAcctRecv(): boolean {
    let returnVal = false;

    if (this.psc.rejected) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscAcctReceivalQueue) &&
      this.calculateRequired('pscAcctReceival') && this.psc.acctReceivedOn == null) {
      returnVal = true;
    }
    return returnVal;
  }

  public canItRecv(): boolean {
    let returnVal = false;
    if (this.psc.rejected) {
      returnVal = false;
    }
    else if (this.permissions.canUpdate(this.permissions.ComponentID.PscItReceivalQueue) &&
      this.calculateRequired('pscItReceival') && this.psc.itReceivedOn == null) {
      returnVal = true;
    }
    return returnVal;
  }

  public zeroOutAlternateNumber(source: string) {
    if (source == 'Contact') {
      this.psc.alternatePhoneTo = '000-000-0000'
    }
    else if (source == 'EmergContact') {
      this.psc.emergencyContactAlternatePhoneTo = '000-000-0000'
    }
  }

  public filterDepartment() {
    this.filteredDepartments = this.allDepartments.filter(d => d.active);
  }

  // Cascading dropdown WorkSection changes when Dept changes -- need both Id and value of dept to update employee record
  public filterWorkSection() {
    this.filteredWorkSections = this.allWorkSections.filter(w => w.departmentId == this.psc.departmentToId && w.active);
  }
  // Cascading dropdown Job Tile changes when WS changes -- need both the Id and value of WS to updated employee record
  public filterJobTitle() {
    this.filteredJobTitles = this.allJobTitles.filter(jt => jt.unionAffiliationId == this.psc.unionAffiliationCodeToId && jt.workSectionId == this.psc.workSectionToId && jt.active);
  }
  // Cascading dropdown Specialty changes when Job Title changes -- need both the Id and value of Specialty to updated employee record
  public filterJobAssignment() {
    this.filteredJobAssignments = this.allJobAssignments.filter(ja => ja.jobTitleId == this.psc.jobTitleToId && ja.active);
    this.loadFyPayRates();
  }

  public updatePscToData() {

    //update only to fields that are id's and have changed
    if (this.psc.employeeStatusToId != null) {
      this.psc.employeeStatusTo = this.allEmployeeStatuses.filter(e => e.employeeStatusId == this.psc.employeeStatusToId).map(e => e.employeeStatus).toString();
    }

    if (this.psc.employmentTypeToId != null) {
      this.psc.employmentTypeTo = this.allEmploymentTypes.filter(e => e.employmentTypeId == this.psc.employmentTypeToId).map(e => e.employmentTypeCode).toString();
    }

    if (this.psc.employmentStatusToId != null) {
      this.psc.employmentStatusTo = this.allEmploymentStatuses.filter(e => e.employmentStatusId == this.psc.employmentStatusToId).map(e => e.employmentStatusCode).toString();
    }

    if (this.psc.permanentSiteCodeToId) {
      this.psc.permanentSiteCodeTo = this.allSites.filter(e => e.siteId == this.psc.permanentSiteCodeToId).map(e => e.siteCode).toString();
    }

    if (this.psc.unionAffiliationCodeToId != null) {
      this.psc.unionAffiliationCodeTo = this.allUnionAffiliations.filter(u => u.unionAffiliationId == this.psc.unionAffiliationCodeToId).map(d => d.unionAffiliationCode).toString();
    }

    if (this.psc.departmentToId != null) {
      this.psc.departmentTo = this.allDepartments.filter(d => d.departmentId == this.psc.departmentToId).map(d => d.department).toString();
    }

    if (this.psc.workSectionToId != null) {
      this.psc.workSectionTo = this.allWorkSections.filter(w => w.workSectionId == this.psc.workSectionToId).map(w => w.workSection).toString();
    }

    if (this.psc.jobTitleToId != null) {
      this.psc.jobTitleTo = this.allJobTitles.filter(j => j.jobTitleId == this.psc.jobTitleToId).map(j => j.jobTitle).toString();
    }

    if (this.psc.jobAssignmentToId != null) {
      this.psc.jobAssignmentTo = this.filteredJobAssignments.filter(s => s.employeeJobAssignmentId == this.psc.jobAssignmentToId).map(s => s.assignmentDescription).toString();
    }

    if (this.psc.homeStateToId != null) {
      this.psc.homeStateTo = this.allStatesOrTerritories.filter(s => s.stateOrTerritoryId == this.psc.homeStateToId).map(s => s.postalCode).toString();
    }

    if (this.psc.mailingStateToId != null) {
      this.psc.mailingStateTo = this.allStatesOrTerritories.filter(s => s.stateOrTerritoryId == this.psc.mailingStateToId).map(s => s.postalCode).toString();
    }

    if (this.psc.driversLicenseStateToId != null) {
      this.psc.driversLicenseStateTo = this.allStatesOrTerritories.filter(s => s.stateOrTerritoryId == this.psc.driversLicenseStateToId).map(s => s.postalCode).toString();
    }

    if (this.psc.clearanceStatusToId != null) {
      this.psc.clearanceStatusTo = this.allclearanceStatuses.filter(c => c.clearanceStatusId == this.psc.clearanceStatusToId).map(c => c.clearanceStatus).toString();
    }

    if (this.psc.maritalStatusToId != null) {
      this.psc.maritalStatusTo = this.allMaritalStatuses.filter(m => m.maritalStatusId == this.psc.maritalStatusToId).map(m => m.maritalStatus).toString();
    }

  }

  public updatePscOccToData() {

    for (let i = 0; i < this.psc.hrPscOcc.length; i++) {
      //update only to fields that are id's and have changed -- otherwise leave null
      if (this.psc.hrPscOcc[i].occStatusToId != null) {
        this.psc.hrPscOcc[i].occStatusTo = (this.allOccStatuses.filter(os => os.occStatusId == this.psc.hrPscOcc[i].occStatusToId).map(os => os.occStatus)).toString();
      }
      if (this.psc.hrPscOcc[i].jobTitleToId != null) {
        this.psc.hrPscOcc[i].jobTitleTo = (this.allJobTitles.filter(jt => jt.jobTitleId == this.psc.hrPscOcc[i].jobTitleToId).map(jt => jt.jobTitle)).toString();
      }
      if (this.psc.hrPscOcc[i].employmentTypeToId != null) {
        this.psc.hrPscOcc[i].employmentTypeTo = (this.allEmploymentTypes.filter(et => et.employmentTypeId == this.psc.hrPscOcc[i].employmentTypeToId).map(et => et.employmentTypeCode)).toString();
      }
      if (this.psc.hrPscOcc[i].workSectionToId != null) {
        this.psc.hrPscOcc[i].workSectionTo = (this.allWorkSections.filter(ws => ws.workSectionId == this.psc.hrPscOcc[i].workSectionToId).map(ws => ws.workSection)).toString();
      }
    }
  }

  //Reject Comment
  public openRejectComment() {
    this.sendRejectEmail = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
      data: {
        header: 'Enter Rejection Reason',
        content: PscRejectCommentDialogComponent,
        contentData: {
                     },
      },
      disableClose: true,
    })

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.rejectionCommentTxt = dialogResult.rejectionComment;
        this.sendRejectEmail = dialogResult.sendRejectEmail;

        this.doReject();
      }
      else {
        this.cancelRejectComment();
      }
    });
  }

  public cancelRejectComment() {
    this.rejectionCommentTxt = null;
  }

  public doReject() {
    let today = new Date();
    this.psc.rejectedOn = today;
    this.psc.rejectedBy = this.user.fullName;
    this.psc.rejected = true;
    this.spinnerText = "Rejecting PSC...";
    this.pscValidStatus = "Rejected";
    //this.showSpinner = true;

    //Insert comment
    this.psc.hrPscComments.unshift(new PscComments(this.psc.pscId, this.user, this.rejectionCommentTxt));

    this.transferHttp.put(`hr/SavePsc`, this.psc).subscribe(retVal => {
      this.loadPsc(retVal.id);
    });

    if (this.sendRejectEmail) {
      this.transferHttp.get(`hr/SendRejectEmail?pscId=${this.psc.pscId}`).subscribe();
    }

    this.rejectionCommentTxt = null;
  }


  ngOnInit(): void {
    this.employeeStatusValues.subscribe(data => { this.allEmployeeStatuses = data; });

    this.employmentTypeValues.subscribe(data => { this.allEmploymentTypes = data; });

    this.employmentStatusValues.subscribe(data => { this.allEmploymentStatuses = data; });

    this.siteValues.subscribe(data => { this.allSites = data; });

    this.pscTypeValues.subscribe(data => { this.allPscTypes = data; this.filteredPscTypes = data; });

    this.unionAffiliationValues.subscribe(data => { this.allUnionAffiliations = data });

    this.departmentValues.subscribe(data => { this.allDepartments = data; this.filteredDepartments = data; });

    this.workSectionValues.subscribe(data => { this.allWorkSections = data; this.filteredWorkSections = data; });

    this.jobTitleValues.subscribe(data => { this.allJobTitles = data; this.filteredJobTitles = data });

    this.employeeJobAssignmentValues.subscribe(data => { this.allJobAssignments = data; this.filteredJobAssignments = data; });

    this.stateOrTerritoryValues.subscribe(data => { this.allStatesOrTerritories = data; });

    this.occStatusValues.subscribe(data => { this.allOccStatuses = data; });

    this.clearanceStatusValues.subscribe(data => { this.allclearanceStatuses = data; });

    this.maritalStatusValues.subscribe(data => { this.allMaritalStatuses = data; });

    this.fyPayRateValues.subscribe(data => { this.allFyPayRates = data; this.filteredToFyPayRates = data; });

    //If id provided, load existing psc data
    this.route.params.subscribe(p => {

      // load in validationData
      this.transferHttp.getHot(`hr/GetEmployeeValidationData?empId=${p["empId"]}`)
        .subscribe(data => {
          this.validationData = data;
        });

      this.routedFrom = p['routedFrom'];

      if (p['pscId'] != null) {
        this.loadPsc(p['pscId']);
      }
      else if (p['empId'] != null) {
        this.createPsc(p['empId']);
      }
      else if (this.routedFrom == 'selfServicePsc') {
        this.filteredPscTypes = this.allPscTypes.filter(pt => pt.canSelfService);
        this.createSelfServicePsc();
      }
      else if (this.routedFrom == 'dmSelfServicePsc') {
        this.filteredPscTypes = this.allPscTypes.filter(pt => pt.dmSelfService);
        this.createDmSelfServicePsc(p['dmSsEmpId']);
      }

    });


  }

}
